import { getUserFields } from "components/user/config";
import { getItemFromCollection, getItemsFromCollection } from "directus/src/operations";

export async function fetchOpeningMeta({ openingId }) {
     try {
        const query = {
            fields: [
                "id",
                getUserFields("sales_coordinator"),
                "skills.skill.id",
                "skills.skill.name",
                "title",
                "description",
                "status",
                "expertise",
                "opportunity_link",
            ],
        };

        const data = await getItemFromCollection("openings", openingId, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
